<template>
  <div>
    <div v-if="direction === 'vertical'">
      <div class="m-b-20">
        <div class="fs-14 flex a-center j-between">
          <slot name="footer">图片分类</slot>
          <div class="flex-1 m-h-10">
            <Select :disabled="disable" :placeholder="placeholder" class=" b-b selectBorder"
                    v-model="objData.classId">
              <Option :key="item.id" :value="item.id" v-for="item in classifyList">
                {{ item.name }}
              </Option>
            </Select>
          </div>
          <slot name="footer_right">

          </slot>

        </div>
      </div>
      <div class="m-b-20">
        <div class="fs-14 flex a-center j-between">
          <slot name="groupTitle">图片分组</slot>
          <div class="flex-1 m-h-10">
            <Select :placeholder="placeholder1" class="b-b selectBorder"
                    v-model="objData.groupId">
              <Option :key="item.id" :value="item.id" v-for="item in groupDatas">
                {{ item.name }}
              </Option>
            </Select>
          </div>
          <slot name="groupTitle_right">

          </slot>
        </div>
      </div>
    </div>
    <div v-if="direction === 'horizontal'">
      <Row :gutter="gutter">
        <Col span="12">
          <div :class="{'flex-row':onLine}" style="">
            <slot name="footer">
              <span class="bold fs-14 color-33">{{leftLabelText}}:</span>
            </slot>
            <Select :class="{'m-t-10':!onLine,'b-b':noBorder,'selectBorder':noBorder}" :disabled="disable"
                    :placeholder="placeholder"
                    v-model="objData.classId">
              <Option :key="item.id" :value="item.id" v-for="item in classifyList">
                {{ item.name }}
              </Option>
            </Select>
          </div>
        </Col>
        <Col span="12">
          <div :class="{'flex-row':onLine}" style="">
            <slot name="groupTitle">
              <span class="bold fs-14 color-33">{{rightLabelText}}:</span>
            </slot>
            <Select :class="{'m-t-10':!onLine,'b-b':noBorder,'selectBorder':noBorder}" :placeholder="placeholder1"
                    v-model="objData.groupId">
              <Option :key="item.id" :value="item.id" v-for="item in groupDatas">
                {{ item.name }}
              </Option>
            </Select>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import Bus from '../../utils/bus'

export default {
  name: 'ClassVerticalChooseWidget',
  props: {
    direction: {
      validator (value) {
        return ['vertical', 'horizontal'].includes(value)
      },
      default: 'vertical'
    },
    gutter: {
      type: Number,
      default: 15
    },
    objData: {
      type: Object,
      default: () => {
        return {
          classId: 0,
          groupId: 0,
          init: false
        }
      }
    },
    srcType: {
      type: Number,
      default: 11
    },

    disable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择分类'
    },
    placeholder1: {
      type: String,
      default: '请选择分组'
    },
    leftLabelText: {
      type: String,
      default: '图片分类'
    },
    rightLabelText: {
      type: String,
      default: '图片分组'
    },
    onLine: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyList: [],
      groupDatas: [],
      fun: null
    }
  },
  watch: {
    'objData.init': {
      async handler (newValue) {
        if (newValue) {
          await this.initFromatClassGroup()
          this.objData.init = false
        }
      },
      immediate: true
    },
    'objData.classId': {
      handler (newValue) {
        if (this.objData.init) {
          return
        }
        if (this.objData.classId) {
          this.getGroupListDatas(this.objData.classId)
        } else {
          this.objData.groupDatas = []
          this.objData.groupId = 0
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  destroyed () {
    Bus.$off('cgChange', this.fun)
  },
  methods: {
    async init () {
      this.classifyList = await this.getClassList()
      this.fun = async (e) => {
        if (parseInt(e.type) === this.srcType) {
          if (e.changeType === 11 || e.changeType === 12 || e.changeType === 13) {
            this.classifyList = await this.getClassList()
            if (e.changeType === 13 && this.objData.classId === e.changeId) {
              // if (this.classifyDatas && this.classifyDatas.length) {
              //   this.objData.classId = this.classifyDatas[0].id || 0
              // } else {
              this.objData.classId = 0
              // }
            }
          } else if (e.changeType === 21 || e.changeType === 22 || e.changeType === 23) {
            if (this.objData.classId > 0) {
              await this.getGroupListDatas(this.objData.classId)
              if (e.changeType === 23 && this.objData.groupId === e.changeId) {
                this.objData.groupId = 0
              }
            }
          }
        }
      }
      Bus.$on('cgChange', this.fun)
    },
    initFromatClassGroup () {
      return new Promise((async (resolve, reject) => {
        if (this.objData.classId) {
          await this.getGroupListDatas(this.objData.classId)
        }
        resolve()
      }))
    },
    getGroupListDatas (pid) {
      return new Promise((resolve, reject) => {
        let params = {
          categoryId: pid,
          type: this.srcType
        }
        this.getGroupLists(params).then(res => {
          this.groupDatas = res.data
          resolve()
        })
      })
    },
    getClassList () {
      return new Promise((resolve, reject) => {
        let params = {
          type: this.srcType,
        }
        this.getCategoryLists(params).then((res) => {
          if (res.code === 0) {
            let arr = res.data
            resolve(arr)
          }
        })
      })
    },
    ...mapActions([
      'getCategoryLists',
      'getGroupLists'
    ])
  }
}
</script>


<style lang="scss" scoped>

  .VideoImg {
    display: block;
  }

  .VideoImgBox {
    color: #333333;
  }

  .VideoImgBox:hover {
    color: #0652DD;
  }

  .VideoImgBox:hover .VideoImg, {
    display: none;
  }

  .VideoImgHover {
    display: none;
  }

  .VideoImgBox:hover .VideoImgHover {
    display: block;
  }

  .titleBg .w-e-toolbar {
    background: #F8F8F9 !important;
    padding-top: 6px;
    border-left: 1px solid #D8D8D8;
    border-top: 1px solid #D8D8D8;
    border-right: 1px solid #D8D8D8;
  }


  .modals .ivu-modal-body {
    padding-bottom: 80px;
    overflow: hidden;
  }


  .modals .ivu-modal-body {
    padding-bottom: 80px;
    overflow: hidden;
  }

  .active {

    background: #EDF3FF;
    color: #0652DD;
  }

  .liHover:hover {
    background: #EDF3FF;

  }

  .liHover:hover .selectHover {
    display: block;

  }

  .selectHover1 {
    display: block;

  }

  .liHover2:hover {
    background: #EDF3FF;
  }

  .inputBoder > .ivu-input {
    border: none;
    padding: 0;
  }

  /*::-webkit-scrollbar {*/
  /*width: 0 !important;*/
  /*}*/

  /*::-webkit-scrollbar {*/
  /*width: 0 !important;*/
  /*!*height: 0;*!*/
  /*}*/
</style>

<style scoped>
  .inputBoder >>> .ivu-input {
    border: none;
    padding: 0;

  }

  .inputBoder >>> .ivu-input:focus {
    box-shadow: none;
  }

  .selectBorder >>> .ivu-select-selection {
    border: none;
    box-shadow: none;
    background: transparent;
  }

  .selectBorder .ivu-select-placeholder {
    padding-left: 0;
  }

  .selectBorder .ivu-select-selection .ivu-select-placeholder {
    padding-left: 0;
  }

  .selectBorder >>> .ivu-select-disabled {
    background: transparent;
  }
</style>

